module.exports = __webpack_public_path__ + "static/scale-model-of-beachaven-vineyards-&-winery-in-clarksville-tennessee-4b1c2c2752cc531ca89da5b53d85f2a3.png";